<template>
    <div class="lg:w-content mx-1">
        <div class="relative w-full p-1 rounded-md
         flex text-white shadow-xl"
             :class="[
                detailsOpen ? 'mb-0 shadow-2xl lg:mb-2 lg:shadow-md rounded-b-none' : 'mb-2 shadow-md',
                isBoosted ? 'border-purple-500' : isSelected ? 'border-green-500' : '',
                runner.jockey?.team === null ? 'bg-[#272727]' : 'bg-rl-' + runner.jockey?.team + ' backdrop-blur-50 bg-opacity-60',
                $page.props.features.stars_not_odds === true ? 'h-[92px]' : 'h-[92px]',
              ]"
             v-if="runner.horse" @click="detailsOpen = !detailsOpen">

             <div class="flex text-white flex-col justify-center p-1 pl-0 w-0 fold:w-14" v-if="runner.jockey?.team !== null">
                <div v-if="runner.jockey?.team !== null" class="p-1 pl-0 w-14 h-14 hidden fold:inline-flex relative items-center justify-center">
                    <!-- Set the image source dynamically using Vue.js interpolation -->
                    <img class="" :src="asset('images/racingleague/rl-' + runner.jockey?.team + '.svg')" :class="[runner.jockey?.team == 'scotland' ? 'w-7' : 'w-10']"/>
                </div>
            </div>

            <div class="flex text-white flex-col justify-center p-1 pl-0 w-0 fold:w-14"
                 v-else-if="runner.silk_image_path !== 'No Image'">
                <div v-if="runner.silk_image_path !== 'No Image'"
                     class="p-1 pl-0 w-14 h-14 hidden fold:inline-flex relative items-center justify-center">
                    <img class="w-10" :src="runner.silk_image_path" />
                </div>
            </div>

            <div class="flex text-white flex-col justify-center p-1 w-2/5 text-ellipsis">
                <div class="flex items-center text-ellipsis whitespace-nowrap mr-3">
                    <div class="flex flex-col w-full">
                        <div class="flex text-xs truncate">
                            <div class="text-[12px] lg:text-base flex fold:mr-1 font-bold whitespace-nowrap truncate" :class="[runner.jockey?.team === null ? 'text-racing-stars-yellow' : 'text-white']">
                                <p class="pr-[6px]">{{ runner.start_number }}</p> 
                                <p class="truncate">
                                    {{ runner.horse.name }}
                                </p>
                            </div>
                        </div>
                        <div class="flex flex-col text-xs mt-1 max-w-4/5 break-all overflow-hidden">
                            <div v-if="runner.jockey" class="mr-2">J: {{ runner.jockey.name }}</div>
                            <div v-if="runner.horse.trainer">T: {{ runner.horse.trainer.name }}</div>
                        </div>
                        <div class="flex content-start md:hidden my-auto text-xs font-semibold">
                            <ChevronDownIcon :class="[detailsOpen ? '-rotate-180' : 'rotate-0']" class="text-white h-3 w-3 my-auto mr-0.5"/>
                            Information
                        </div>
                        <Popper placement="top" arrow="true" style="--popper-theme-background-color:#030712;--popper-theme-background-color-hover:#030712;" class="cursor-pointer">
                            <div class="hidden md:flex my-auto text-sm font-semibold mt-1"><InformationCircleIcon class="text-white h-4 w-4 my-auto mr-1"/>Information</div>
                            <template #content>
                                <div class="hidden md:flex flex-col bg-gray-950 my-2 p- rounded-b text-xs text-white w-full">
                                    <div class="flex mb-2">
                                        <p class="font-bold text-sm">Horse Name: </p>
                                        <p class="my-auto ml-1 font-medium text-sm">{{ runner.horse.name }}</p>
                                    </div>
                                    <div v-if="runner.horse && runner.horse.trainer" class="flex mb-2">
                                        <strong>T: </strong>
                                        <p class="my-auto ml-1 font-medium">{{ runner.horse.trainer.name }}</p>
                                    </div>
                                    <div class="flex mb-2">
                                        <div class="flex mr-2">
                                            <strong class="text-white mr-1">Weight: </strong>
                                            <p class="font-medium">{{ runner.weight }}</p>
                                        </div>
                                        <div v-if="runner.horse && runner.horse.rating" class="flex mr-2">
                                            <strong class="mr-1">Rating: </strong>
                                            <p class="font-medium">{{ runner.horse.rating }}</p>
                                        </div>
                                        <div class="flex mr-2">
                                            <strong class="mr-1">Age: </strong>
                                            <p class="font-medium">{{ runner.horse.age }}</p>
                                        </div>
                                        <div v-if="runner.horse" class="flex mr-2">
                                            <strong class="mr-1">Form: </strong>
                                            <p class="font-medium">{{ runner.horse ? runner.horse.form : '' }}</p>
                                        </div>
                                        <div class="flex mr-2">
                                            <strong class="mr-1">Draw: </strong>
                                            <p class="font-medium">{{ runner.draw }}</p>
                                        </div>
                                    </div>
                                    <!-- <div class="flex">{{ runner.horse.spotlight }}</div> -->
                                </div>
                            </template>
                        </Popper>
                    </div>
                    <!-- <div class="flex content-start md:hidden"><ChevronDownIcon :class="[detailsOpen ? '-rotate-180' : 'rotate-0']" class="text-white h-4 w-4"/></div> -->
                </div>
            </div>
            <div class="flex w-full items-end justify-end">
                <Popper v-if="$page.props.settings.site_name == 'Racing League'" placement="top" arrow="true" style="--popper-theme-background-color:#1f2937;--popper-theme-background-color-hover:#1f2937;margin: 0px" class="cursor-pointer">
                    <div class="hidden md:flex my-auto"><InformationCircleIcon class="text-white h-5 w-5 mr-1 my-4"/></div>
                    <template #content>
                        <div class="hidden md:flex flex-col bg-gray-800 my-2 p- rounded-b text-xs text-white w-full">
                            <div class="flex mb-2">
                                <p class="font-bold text-sm">Horse Name: </p>
                                <p class="my-auto ml-1 font-medium text-sm">{{ runner.horse.name }}</p>
                            </div>
                            <div v-if="runner.horse && runner.horse.trainer" class="flex mb-2">
                                <strong>T: </strong>
                                <p class="my-auto ml-1 font-medium">{{ runner.horse.trainer.name }}</p>
                            </div>
                            <div class="flex mb-2">
                                <div class="flex mr-2">
                                    <strong class="text-white mr-1">Weight: </strong>
                                    <p class="font-medium">{{ runner.weight }}</p>
                                </div>
                                <div v-if="runner.horse && runner.horse.rating" class="flex mr-2">
                                    <strong class="mr-1">Rating: </strong>
                                    <p class="font-medium">{{ runner.horse.rating }}</p>
                                </div>
                                <div class="flex mr-2">
                                    <strong class="mr-1">Age: </strong>
                                    <p class="font-medium">{{ runner.horse.age }}</p>
                                </div>
                                <div v-if="runner.form" class="flex mr-2">
                                    <strong class="mr-1">Form:</strong>
                                    <p class="font-medium">{{ runner.form ? runner.form : 'None' }}</p>
                                </div>
                                <div class="flex mr-2">
                                    <strong class="mr-1">Draw: </strong>
                                    <p class="font-medium">{{ runner.draw }}</p>
                                </div>
                            </div>
                            <!-- <div class="flex">{{ runner.horse.spotlight }}</div> -->
                        </div>
                    </template>
                </Popper>

<!--                <div v-if="isSelected && !runner.non_runner" class="text-xs flex items-end justify-center text-center mr-1 my-auto">-->
<!--                    <div class="dark:text-white p-2 rounded-t w-20 text-center font-bold" v-if="runner.irish_reserve">Reserve</div>-->
<!--                    &lt;!&ndash; <div class="dark:text-white p-2 rounded-t w-20 text-center font-bold" v-if="runner.irish_reserve">Reserve</div> &ndash;&gt;-->
<!--                    <div class="dark:text-white px-0 pt-1 my-auto rounded-t w-10 text-center font-bold pr-1" v-else>-->
<!--                        {{ getOddsDescription(runner.forecast_odds_description) }}-->
<!--                    </div>-->
<!--                </div>-->

                <div v-if="!runner.non_runner" class="text-xs flex items-end justify-center text-center mr-1 my-auto">
                    <div class="dark:text-white px-0 my-auto rounded-t text-center font-bold pr-2" v-if="runner.irish_reserve">
                        Reserve
                    </div>

                            <div class="flex flex-col items-center">
                                <div v-if="isSelected" class="bg-green-600 flex flex-col text-black p-1 md:p-2 rounded-md w-16 ml-1 text-center cursor-pointer my-auto border-2 border-black">
                                    <CheckIcon class="w-4 lg:w-5 font-bold m-auto" />
                                    <span v-if="$page.props.features.stars_not_odds === false" class="font-bold border-t-2 border-black w-full text-xs">
                                        {{getOddsDescription(runner.forecast_odds_description)}}
                                    </span>
                                </div>
                                <div v-else-if="isBoosted" class="bg-purple-500 flex flex-col text-black p-1 md:p-2 rounded-md w-16 ml-1 text-center cursor-pointer my-auto border-2 border-black">
                                    <LightningBoltIcon class="w-4 lg:w-5 font-bold m-auto text-white" />
                                    <span v-if="$page.props.features.stars_not_odds === false" class="font-bold border-t-2 border-black w-full text-xs">
                                        {{getOddsDescription(runner.forecast_odds_description)}}
                                    </span>
                                </div>
                                <div v-else-if="!isBoosted" class="bg-racing-stars-yellow flex flex-col text-gray-900 p-1 md:p-2 rounded-md w-16 ml-1 text-center cursor-pointer my-auto border-2 border-black" @click.stop="selectRunner(runner);">
                                    <p class="text-xs md:text-sm align-middle font-semibold w-full">Pick</p>
                                    <span v-if="$page.props.features.stars_not_odds === false" class="font-bold border-t-2 border-black w-full text-xs">
                                        {{getOddsDescription(runner.forecast_odds_description)}}
                                    </span>
                                </div>

                                <div class="w-full flex flex-row text-white text-center font-bold text-xs" v-if="$page.props.features.stars_not_odds === true" >
                                    <div class="flex">
                                        <div class="flex whitespace-nowrap">
                                            <template v-for="star in Math.floor(runner.star_rating)">
                                                <StarIcon class="text-white h-5 w-3 mr-0.5 my-1.5 stroke-1 stroke-current" />
                                            </template>
                                        </div>

                                    <template v-if="runner.star_rating - Math.floor(runner.star_rating) > 0">
                                            <svg class="text-white h-5 w-3 mr-0.5 my-1.5"
                                                 viewBox="-0.5 -0.35 5.2 5.2"
                                                 version="1.1"
                                                 id="svg5"
                                                 xmlns="http://www.w3.org/2000/svg"
                                                 xmlns:svg="http://www.w3.org/2000/svg">
                                                <defs
                                                    id="defs2">
                                                    <clipPath
                                                        clipPathUnits="userSpaceOnUse"
                                                        id="clipPath954">
                                                        <rect
                                                            style="opacity:0.643512;fill:#ffffff;fill-opacity:1;stroke:#ffffff;stroke-width:0.2;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:0;paint-order:markers stroke fill"
                                                            id="rect956"
                                                            width="3.7340364"
                                                            height="7.1398091"
                                                            x="259.22318"
                                                            y="96.550743"
                                                            ry="1.8670182" />
                                                    </clipPath>
                                                </defs>
                                                <g
                                                    id="layer1"
                                                    transform="translate(-263.66324,-98.488591)">
                                                    <path
                                                        d="m 265.50968,98.803649 c 0.0794,-0.243681 0.42413,-0.243681 0.50324,0 l 0.2831,0.871008 a 0.26458333,0.26458333 0 0 0 0.25135,0.182563 h 0.91599 c 0.25638,0 0.36275,0.32808 0.15558,0.4789 l -0.74084,0.53816 a 0.26458333,0.26458333 0 0 0 -0.0963,0.2958 l 0.28311,0.87101 c 0.0794,0.24368 -0.19976,0.44662 -0.40746,0.29581 l -0.74083,-0.53817 a 0.26458333,0.26458333 0 0 0 -0.31089,0 l -0.74083,0.53817 c -0.20743,0.15081 -0.48631,-0.0521 -0.4072,-0.29581 l 0.28311,-0.87101 a 0.26458333,0.26458333 0 0 0 -0.0963,-0.2958 l -0.74057,-0.5379 c -0.20717,-0.15081 -0.10054,-0.478896 0.15558,-0.478896 h 0.91572 a 0.26458333,0.26458333 0 0 0 0.25162,-0.182562 l 0.2831,-0.871009 z"
                                                        id="path132"
                                                        style="fill:none;fill-opacity:1;stroke:#ffffff;stroke-width:0.264583;stroke-opacity:1" />
                                                    <path
                                                        d="m 262.80536,98.71315 c 0.0794,-0.243681 0.42413,-0.243681 0.50324,0 l 0.2831,0.871008 a 0.26458333,0.26458333 0 0 0 0.25135,0.182563 h 0.91599 c 0.25638,0 0.36275,0.328079 0.15558,0.478899 l -0.74084,0.53816 a 0.26458333,0.26458333 0 0 0 -0.0963,0.2958 l 0.28311,0.87101 c 0.0794,0.24368 -0.19976,0.44662 -0.40746,0.29581 l -0.74083,-0.53817 a 0.26458333,0.26458333 0 0 0 -0.31089,0 l -0.74083,0.53817 c -0.20743,0.15081 -0.48631,-0.0521 -0.4072,-0.29581 l 0.28311,-0.87101 a 0.26458333,0.26458333 0 0 0 -0.0963,-0.2958 l -0.74057,-0.5379 c -0.20717,-0.15081 -0.10054,-0.478895 0.15558,-0.478895 h 0.91572 a 0.26458333,0.26458333 0 0 0 0.25162,-0.182562 l 0.2831,-0.871009 z"
                                                        id="path132-3"
                                                        style="fill:#ffffff;fill-opacity:1;stroke-width:0.264583"
                                                        clip-path="url(#clipPath954)"
                                                        transform="translate(2.8128463,0.08967728)" />
                                                </g>
                                            </svg>
                                </template>

                                <template v-for="star in 5 - Math.ceil(runner.star_rating)">
                                    <StarIconOutline class="text-white h-4.5 w-3 mr-0.5 my-1.5" />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="runner.non_runner" class="text-xs flex items-end justify-center flex-col">
                    <div class=" text-white p-2 pt-1 rounded w-20 text-center cursor-pointer"><strong>Non-Runner</strong></div>
                </div>
            </div>
        </div>

        <div v-if="detailsOpen" class="flex flex-col bg-[#272727] mb-2 p-4 rounded text-xs text-white w-full md:hidden rounded-t-none">
            <div class="flex mb-2">
                <p class="font-bold text-xs">Horse Name: </p>
                <p class="my-auto ml-1 font-medium text-xs">{{ runner.horse.name }}</p>
            </div>
            <div v-if="runner.horse && runner.horse.trainer" class="flex mb-2">
                <strong>T: </strong>
                <p class="my-auto ml-1 font-medium">{{ runner.horse.trainer.name }}</p>
            </div>
            <div class="flex flex-col mb-2">
                <div class="flex mr-2">
                    <strong class="text-white mr-1">Weight: </strong>
                    <p class="font-medium">{{ runner.weight }}</p>
                </div>
                <div v-if="runner.horse && runner.horse.rating" class="flex mr-2">
                    <strong class="mr-1">Rating: </strong>
                    <p class="font-medium">{{ runner.horse.rating }}</p>
                </div>
                <div class="flex mr-2">
                    <strong class="mr-1">Age: </strong>
                    <p class="font-medium">{{ runner.horse.age }}</p>
                </div>
                <div v-if="runner.form" class="flex mr-2">
                    <strong class="mr-1">Form: </strong>
                    <p class="font-medium">{{ runner.form }}</p>
                </div>
                <div class="flex mr-2">
                    <strong class="mr-1">Draw: </strong>
                    <p class="font-medium">{{ runner.draw }}</p>
                </div>
            </div>
            <!-- <div class="flex">{{ runner.horse.spotlight }}</div> -->
        </div>
    </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { CheckIcon, ChevronDownIcon, LightningBoltIcon, StarIcon as StarIconOutline } from '@heroicons/vue/outline'
import { InformationCircleIcon, StarIcon } from '@heroicons/vue/solid'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions  } from '@headlessui/vue'
import Popper from 'vue3-popper'
import TwButton from '@/Global/Elements/TwButton.vue'
import TwCard from '@/Global/Elements/TwCard.vue'
import TwModal from '@/Global/Elements/TwModal.vue'

export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        meeting: {
            type: Object,
            default: {}
        },
        selections: {
            type: Object,
            default: {}
        },
        bets: {
            type: Array,
            default: []
        },
        runner: {
            type: Object,
            default: {}
        },
        showPercentage: {
            type: Object,
            default: {}
        },
    },

    emits: ['runnerSelected', 'updateRunner', 'toggleDetails', 'scrollToElement'],

    setup(props, { emit }) {

        const store = useStore()

        const detailsOpen = ref(false)

        const showPlaceBetModal = ref(false)

        const removeBooster = () => {
            axios.post(route('api.bet.clearBoost'), {
                meeting_id : props.meeting.id
            })
        }
        const applyBooster = (runnerID, boosterType, meetingID) => {
            axios.post(route('api.boosters.set'), {
            })
        }

        const hasBet = () => {
            let hasBet = false

            props.meeting.bets.forEach(bet => {
                props.bets.forEach(userBet => {
                    if (userBet.id === bet.id) {
                        hasBet = true
                    }
                })
            })

            return hasBet
        }

        const isSelected = computed(() => {
            let selected = false

            if (Object.keys(props.selections).length) {
                store.commit('removeSelectedRunners', props.meeting)

                Object.keys(props.selections).forEach(key => {
                    if (props.selections[key].race.id == props.runner.race.id && props.selections[key].id == props.runner.id) {
                        selected = true
                    }
                })
            } else {
                Object.keys(store.state.play.selectedRunners).forEach(key => {
                    if (key == props.runner.race.id && store.state.play.selectedRunners[key].id == props.runner.id) {
                        selected = true
                    }
                })
            }

            return selected
        })

        const isBoosted = computed(() => {
            let boosted = false

            if (Object.keys(props.selections).length) {
                Object.keys(props.selections).forEach(key => {
                    if (props.selections[key].race.id == props.runner.race.id && props.selections[key].id == props.runner.id && props.selections[key].boost_applied_to) {
                        boosted = true
                    }
                })
            }

            return boosted
        })

        const getMultiplier = computed(() => {
            let multiplier = false

            if (Object.keys(props.selections).length) {
                Object.keys(props.selections).forEach(key => {
                    if (props.selections[key].race.id == props.runner.race.id && props.selections[key].id == props.runner.id && props.selections[key].boost_applied_to) {
                        multiplier = props.selections[key].multiplier
                    }
                })
            }

            return multiplier;
        })

        const selectRunner = (runner) => {
            if (hasBet()) {
                emit('updateRunner', runner)
            } else {
                emit('runnerSelected', runner)
            }

            // If site is in mobile view disable scrollToElement
            if (window.innerWidth > 640) {
                emit('scrollToElement')
            }
        }

        return {
            isSelected,
            isBoosted,
            getMultiplier,
            selectRunner,
            detailsOpen,
            showPlaceBetModal,
            removeBooster,
            applyBooster,
            hasBet,
        }

    },

    components: {
        CheckIcon,
        StarIcon,
        ChevronDownIcon,
        InformationCircleIcon,
        Popper,
        LightningBoltIcon,
        Listbox,
        ListboxButton,
        ListboxOption,
        ListboxOptions,
        TwButton,
        TwCard,
        TwModal,
        StarIconOutline
    },

    methods: {
        getOddsDescription(oddsDescription) {
            // If oddsDescription has no value return 'no odds'.
            if (!oddsDescription)
                return 'No Odds';

            // If the api returns 'Evs' for probability return the same.
            else if (oddsDescription === 'Evs')
                return oddsDescription;

            // If showPercentage is toggled convert given description to percentage and return.
            if (this.showPercentage) {
                const oddsSplit = oddsDescription.split('/');

                return parseFloat((Number(oddsSplit[1]) / (Number(oddsSplit[1]) + Number(oddsSplit[0])) * 100).toPrecision(2)) + "%";
            }

            // If show percentage is not toggled return oddsDescription as a fraction.
            return oddsDescription;
        },
    }
}
</script>
